var render, staticRenderFns
import script from "./HyperlinkKpiTechnicalSupport.vue?vue&type=script&lang=js&"
export * from "./HyperlinkKpiTechnicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./HyperlinkKpiTechnicalSupport.vue?vue&type=style&index=0&id=642d1bc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d1bc3",
  null
  
)

export default component.exports